import { render, staticRenderFns } from "./CustomerFeedbackCSVPage.vue?vue&type=template&id=2932a5d6&"
import script from "./CustomerFeedbackCSVPage.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedbackCSVPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports